<template>
  <tbody>
    <tr v-if="!rows2.records || rows2.records.length < 1">
      <td colspan="7" align="center">No records found.</td>
    </tr>
    <tr v-for="(row, index) in rows2.records" :key="index">
      <td>
        <span class="agent-info">{{ row.agent_name }} ({{ row.agent_code??'' }})</span>
      </td>
      <td>
        <span class="special-way">${{ row.special_commisssion }}</span>
        <div v-if="row.special_commisssion > 0 || row.special_pdf_link !== null">
          <div class="action-icons">
            <a :href="row.special_pdf_link" v-b-tooltip.hover title="Download PDF" download target="_blank">
              <i class="fas fa-file-pdf"></i>
            </a>
            <a :href="row.special_csv_link" v-b-tooltip.hover title="Download CSV" download target="_blank">
              <i class="fas fa-file-csv" />
            </a>
          </div>
        </div>
      </td>
      <td>
        <span class="one-time">${{ row.onetime_commmission }}</span>
        <div v-if="row.onetime_commisssion > 0 || row.onetime_pdf_link !== null ">
          <div class="action-icons">
            <a :href="row.onetime_pdf_link" v-b-tooltip.hover title="Download PDF" download target="_blank">
              <i class="fas fa-file-pdf"></i>
            </a>
            <a :href="row.onetime_csv_link" v-b-tooltip.hover title="Download CSV" download target="_blank">
              <i class="fas fa-file-csv" />
            </a>
          </div>
        </div>
      </td>
      <td>
        <span class="association">${{ row.association_commmission }}</span>
        <div v-if="row.association_commmission > 0 || row.association_pdf_link !== null">
          <div class="action-icons">
            <a :href="row.association_pdf_link" v-b-tooltip.hover title="Download PDF" download target="_blank">
              <i class="fas fa-file-pdf"></i>
            </a>
            <a :href="row.association_csv_link" v-b-tooltip.hover title="Download CSV" download target="_blank">
              <i class="fas fa-file-csv" />
            </a>
          </div>
        </div>
      </td>
      <td>
        <span class="overall-amount">${{ row.other_comm_total }}</span>
      </td>
      <td>
        <span class="month-year">{{ row.date }}</span>
      </td>
      <td>
        <span class="payment-status">{{ row.payment_status.toUpperCase() }}</span>
      </td>
    </tr>
  </tbody>
</template>
  
<script>
  export default {
    name: "OthersCommissionTable",
     props: {
      rows2: {
      required: true,
      },
     },
    data() {
      return {
        rows: [
          {
            agent_name: "John Doe",
            agent_code: "AGT001",
            special_way: 120.0,
            one_time: 50.0,
            association: 30.0,
            overall_amount: 200.0,
            month_year: "March 2025",
            payment_status: "Paid",
            pdf_link: "/files/others/john_doe_march2025.pdf",
            csv_link: "/files/others/john_doe_march2025.csv",
          },
          {
            agent_name: "Jane Smith",
            agent_code: "AGT002",
            special_way: 80.0,
            one_time: 40.0,
            association: 20.0,
            overall_amount: 140.0,
            month_year: "March 2025",
            payment_status: "Pending",
            pdf_link: "/files/others/jane_smith_march2025.pdf",
            csv_link: "/files/others/jane_smith_march2025.csv",
          },
        ],
      };
    },
  };
</script>
  
<style scoped>
  .agent-info {
    font-weight: 500;
  }
  .action-icons {
    display: flex;
    align-items: center;
  }
  .action-icons a {
    margin-left: 8px;
    color: #333;
  }
  .month-year,
  .payment-status {
    font-size: 14px;
  }
</style>
  